import { useEffect, useState } from 'react';
import type { RuleBasedDeleteCommands } from '../../types';
import {
  bulkDeleteOperations,
  type RuleBasedDeletePreview,
} from './bulkDeleteOperations';

export type GetRuleBasedDeletePreview =
  RuleBasedDeleteCommands['getRuleBasedDeleteComponentCount'];

export const useRuleBasedDeleteComponentPreview = (
  getBulkDeleteComponentCount: GetRuleBasedDeletePreview
): RuleBasedDeletePreview => {
  const [count, setCount] = useState<RuleBasedDeletePreview>({
    status: 'loading',
  });

  useEffect(() => {
    let isCurrentRequest = true;
    const settle = (settled: RuleBasedDeletePreview) => {
      if (isCurrentRequest) {
        setCount(settled);
      }
    };
    getBulkDeleteComponentCount()
      .then(result => settle(bulkDeleteOperations.toBulkDeleteCount(result)))
      // A command that rejects rather than resolving an ArdoqError would
      // otherwise leave the dialog loading for good. The command owns logging.
      .catch(() => settle({ status: 'error' }));
    return () => {
      isCurrentRequest = false;
    };
  }, [getBulkDeleteComponentCount]);

  return count;
};
